import type { IncrementView, SequenceView } from "@services/drybulkCargoOperationsApi";
import {
  EQUIPMENT_EDITABLE_OPERATION_STATUSES,
  EQUIPMENT_EDITABLE_SEQUENCE_STATUSES,
  INCREMENT_WRITABLE_OPERATION_STATUSES,
} from "../constants";

export interface ExecutionActions {
  equipment: boolean;
  start: boolean;
  /** DBCO-0076: why an UPCOMING sequence cannot be started yet, for the disabled Start item. */
  startBlocked: StartBlocked | null;
  add: boolean;
  /** The open (STARTED) increment the Complete action finishes. */
  complete: IncrementView | null;
}

export type StartBlocked = "shipper-readiness";

const STARTED = "STARTED";

/**
 * DBCO-0048 - which execution actions are offered for a sequence, read from the statuses and increments the server returned
 * (F6): UPCOMING starts; ONGOING without an open increment adds; ONGOING with an open increment completes. Display only:
 * the server enforces every window and one open increment, and its refusal is rendered.
 *
 * DBCO-0076 (AD-77, part 2 superseded by AD-78): an UPCOMING sequence starts as soon as the operation is Shipper Ready (or
 * Ongoing); sibling sequences still Pending Information no longer block. The ATB is not an input: Start stays enabled without
 * one, because the press runs the berth-arrival re-query.
 */
export const executionActions = (
  sequence: SequenceView,
  operationStatus: string | null,
): ExecutionActions => {
  const status = operationStatus ?? "";
  const open = (sequence.increments ?? []).find((increment) => increment.state === STARTED) ?? null;
  const writable = INCREMENT_WRITABLE_OPERATION_STATUSES.includes(status);
  const upcoming = sequence.status === "UPCOMING";
  const startBlocked: StartBlocked | null =
    upcoming && status === "PENDING_SHIPPER_READINESS" ? "shipper-readiness" : null;
  return {
    equipment:
      EQUIPMENT_EDITABLE_OPERATION_STATUSES.includes(status) &&
      EQUIPMENT_EDITABLE_SEQUENCE_STATUSES.includes(sequence.status),
    start: writable && upcoming && startBlocked === null,
    startBlocked,
    add: writable && sequence.status === "ONGOING" && open === null,
    complete: writable && sequence.status === "ONGOING" ? open : null,
  };
};
